import { ClbAvatar } from "@celebration/react/ClbAvatar/ClbAvatar";
import type { AvatarProps } from "@components/contracts/Avatar.types";
import type React from "react";

export const CelebrationAvatar: React.FC<AvatarProps> = (props) => (
  <ClbAvatar {...props} />
);
